const all = ['statsAssistant'] as const

export const statsAssistantKeys = {
  all,
  agents: [...all, 'agents'] as const,
  /** Préfixe commun à toutes les listes d'historique (toutes recherches). */
  conversationsRoot: [...all, 'conversations'] as const,
  conversations: (search?: string) => [...all, 'conversations', { search: search ?? '' }] as const,
  conversation: (ulid: string) => [...all, 'conversation', ulid] as const,
}
